// @flow

import React from 'react';
import {ThemeProvider} from 'styled-components';
import {DefaultTheme as SplunkDefaultTheme, DarkTheme as SplunkDarkTheme, LegacyDefaultTheme, LegacyDarkTheme} from 'trustar-2.0/themes';
import {theme} from 'modules/app/getters';
import {connect} from 'react-redux';
import {PrismaGlobals} from '../../../web_modules/trustar-2.0/themes/common/globalSnippets.styles';
import styled from 'styled-components';

import * as Features from 'modules/features';

type ConnectedDesignSystemProviderPropType = {
  children: any,
  theme: 'default' | 'dark',
  noBootstrap: boolean,
  useSplunkTheme: boolean,
};

const initialValues = {
  theme: 'default',
  noBootstrap: false,
};

const StyledSplunkContainer = styled.div`
  ${PrismaGlobals}
`;

const ConnectedDesignSystemProvider = (props: ConnectedDesignSystemProviderPropType) => {
  const className = props.theme === 'dark' ? 'trustar-dark' : 'trustar'; // revert to trustar-dark dark theme later


  // Temporary Feature Flag as we roll out splunk theme
  let DarkTheme = props.useSplunkTheme ? SplunkDarkTheme : LegacyDarkTheme;
  let DefaultTheme = props.useSplunkTheme ? SplunkDefaultTheme : LegacyDefaultTheme;

  const themeConfiguration = props.theme === 'dark' ? DarkTheme : DefaultTheme; // revert to dark theme later

  return props.noBootstrap ?
    (
      <ThemeProvider theme={themeConfiguration}>
          {props.children}
      </ThemeProvider>
    )
    :
    (
      <div className={props.noBootstrap ? null :className}>
          {props.children}
      </div>
    );
};

ConnectedDesignSystemProvider.defaultProps = initialValues;

const mapState = state => {
  return {
    theme: theme(state),
    useSplunkTheme: Features.getters.isFeatureEnabled(Features.flags.SPLUNK_THEMES_ENABLED)(state),
  };
};
const mapDispatch = {};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...dispatchProps,
  ...stateProps,
});

export default connect(mapState, mapDispatch, mergeProps)(ConnectedDesignSystemProvider);



// WEBPACK FOOTER //
// ./src/app/components/ConnectedDesignProvider.js